module.exports = __webpack_public_path__ + "static/media/Bebe.af437abe.png";